<template>
  <div>
    <div class="query-select">
      <el-form ref="form" :model="form" :inline="true" class="user-search">
        <el-form-item label="考生姓名：">
          <el-input
            size="small"
            v-model="form.examMemberName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="考试名称：">
          <el-select
            @change="getTableInfo"
            clearable
            v-model="form.examinationId"
            size="small"
            placeholder="请选择"
          >
            <el-option
              :label="item.examName"
              :value="item.examinationId"
              v-for="(item, index) in classData"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试开始时间：">
          <el-date-picker
            size="small"
            @change="getTableInfo"
            v-model="form.examStartTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          type="primary"
          icon="el-icon-search"
          plain
          size="small"
          round
          @click="select"
          >查询</el-button
        >

        <el-button
          type="warning"
          icon="el-icon-refresh-left"
          plain
          size="small"
          round
          @click="resetSelect"
          >重置</el-button
        >
        <el-button
          type="success"
          icon="el-icon-download"
          plain
          size="small"
          round
          @click="exportData"
          >导出</el-button
        >
      </div>
    </div>
    <div class="main-table">
      <el-table
        :data="tableData"
        style="width: 85vw"
        border
        stripe
        size="small"
        v-loading="loading"
        show-overflow-tooltip
        header-cell-class-name="table-header"
      >
        <el-table-column width="50" type="index" align="center">
        </el-table-column>
        <el-table-column
          prop="examMemberCode"
          label="考号"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="examMemberName"
          label="考生姓名"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="examName" label="考试名称" align="center">
        </el-table-column>
        <el-table-column
          prop="examScore"
          label="理论考试成绩"
          align="center"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="practicalScore"
          label="实操考试成绩"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            {{
              Number(scope.row.practicalScore || 0) +
                Number(scope.row.practicalShortScore || 0)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="examStartTime"
          label="开考日期"
          align="center"
          width="180"
          :formatter="dateFormat"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="240">
          <template slot-scope="scope">
            <el-button
              type="primary"
              @click="theoryOpen(scope.row, 'review')"
              plain
              size="mini"
              round
              >理论试卷</el-button
            >
            <el-button
              type="primary"
              @click="handsOnOpen(scope.row, 'review')"
              plain
              size="mini"
              round
              >实操试卷</el-button
            >
            <!-- <el-button
              type="warning"
              @click="review(scope.row, 'edit')"
              plain
              size="mini"
              round
              >编辑</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="form.pageNum"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <TheoryDialog ref="TheoryDialogRef" @success="getTableInfo" />
    <HandsOnDialog ref="HandsOnDialogRef" @success="getTableInfo" />
  </div>
</template>
<script>
import { getGradesTable, classGrade } from "@/api/manage";
import { getExamAll } from "@/api/exam";
import download from "@/utils/download";
import { gradeDownload } from "@/api/grade";
import { timestampToTime } from "@/utils/util";
import TheoryDialog from "./TheoryDialog.vue";
import HandsOnDialog from "./HandsOnDialog.vue";
import Chart from "echarts";
export default {
  name: "welcome",
  data() {
    return {
      loading: false,
      tableData: null,
      totalCount: 0,
      form: {
        pageNum: 1,
        pageSize: 10,
        examMemberName: null,
        examinationId: null,
        examStartTime: null
      },
      classData: null,
      schoolData: null
    };
  },
  // 导入组件
  components: {
    // 点聚合组件
    TheoryDialog,
    HandsOnDialog
  },
  // 创建完毕状态(里面是操作)
  created() {
    // this.getTrends()
    // this.getStatistics()
  },
  // 挂载结束状态(里面是操作)
  mounted() {
    this.loading = true;
    this.getTableInfo();
    // this.getClass()
    this.getAllTrain();
  },
  // 里面的函数只有调用才会执行
  methods: {
    dateFormat(row, column) {
      return timestampToTime(row.examStartTime).split(" ")[0];
    },
    async exportData() {
      const res = await gradeDownload(this.form);
      download.excel(res.data, "成绩导出.xlsx");
      // download("/trainAdmin/questionMemberInfo/export", "成绩导出.xlsx", {});
    },
    handleEdit(row) {},
    async select() {
      let obj;
      let requireAddress;

      const params = {
        pageNum: this.form.pageNum,
        pageSize: 10,
        examMemberName: this.form.examMemberName,
        examStartTime: this.form.examStartTime,
        examinationId: this.form.examinationId
      };
      const res = await getGradesTable(params);
      let result = res.data;
      if (result.code === 200) {
        this.loading = false;
        this.tableData = res.data.data.rows;
        this.totalCount = res.data.data.total;
      } else {
        this.loading = false;
      }
    },

    theoryOpen(row, type) {
      this.$refs.TheoryDialogRef.open(row, type);
    },
    handsOnOpen(row, type) {
      this.$refs.HandsOnDialogRef.open(row, type);
    },
    changeSchool() {
      this.getTableInfo();
    },
    changeClass() {
      this.getTableInfo();
    },
    async getTableInfo() {
      const res = await getGradesTable(this.form);

      if (res.data.code === 200) {
        this.loading = false;
        this.tableData = res.data.data.rows;
        this.totalCount = res.data.data.total;
      } else {
        this.loading = false;
      }
    },

    async getAllTrain() {
      const res = await getExamAll();
      this.classData = res.data.data;
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getTableInfo();
    },
    resetSelect() {
      this.form.pageNum = 1;
      this.form.examMemberName = null;
      this.form.examinationId = null;
      this.form.examStartTime = null;
      this.getTableInfo();
    }
  }
};
</script>
<style lang="less" scoped>
.tools {
  // height: 3.75rem;
  // height: 6.25%;
  width: 100%;
  background: #ffffff;
  border-radius: 0.375rem;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/GradeManage/GradeManage.vue